/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { PureComponent } from 'react';
import './OTP.scss';
import { injectIntl } from 'react-intl';
import connect from 'shared/context/connect';
import moment from 'moment';
import MarkazIcon from 'assets/icons/logo.png';
import { handleOTP, handleResendOTP } from 'shared/context/actions';
import { errorMessage, clearAllToast } from 'utils/ErrorHandler';

let interval = null;
const timeout = null;
const CODE_LENGTH = new Array(4).fill(0);

interface State {
  timer: any,
  value: string,
  focused: boolean,
}

interface Props {
  history: { location, push },
  intl: { formatMessage },
  onHandleOTP,
  clientData,
  onHandleResendOTP
}

class OTP extends PureComponent<Props, State> {
  input: React.RefObject<HTMLInputElement>;

  constructor(props) {
    super(props);
    this.state = {
      timer: 60000,
      value: '',
      focused: false,
    };
    this.input = React.createRef();
  }

  componentDidMount() {
    // initial input typing
    this.input.current.style.caretColor = 'transparent';
    this.handleFocus();

    // start resend code duration
    this.resendCodeDuration();
  }

  componentDidUpdate() {
    const { timer } = this.state;
    if (timer === 0) {
      clearInterval(interval);
    }
  }

  componentWillUnmount() {
    clearInterval(interval);
    clearTimeout(timeout);
  }

  handleResendCode = () => {
    const { onHandleResendOTP, history } = this.props;
    this.setState({
      timer: 60000,
      value: '',
    }, () => {
      onHandleResendOTP().catch(() => {
        errorMessage('Session has expired, please login again.');
        setTimeout(() => {
          clearAllToast();
          history.push('/');
        }, 3000);
      });
      this.resendCodeDuration();
    });
  }

  resendCodeDuration = () => {
    interval = setInterval(() => {
      this.setState((state) => ({
        timer: state.timer - 1000,
      }));
    }, 1000);
  }

  handleKeyUp = (e) => {
    if (e.key === 'Backspace') {
      this.setState((state) => ({
        value: state.value.slice(0, state.value.length - 1),
      }));
    }
  };

  handleChange = ({ target }) => {
    const { history, onHandleOTP } = this.props;
    this.setState(({ value }) => {
      if (value.length >= CODE_LENGTH.length) return null;
      return {
        value: (value + target.value).slice(0, CODE_LENGTH.length),
      };
    }, () => {
      const { value } = this.state;
      if (value.length === CODE_LENGTH.length) onHandleOTP(value, history);
    });
  };

  handleFocus = () => {
    this.input.current.focus();
    this.setState({ focused: true });
  };

  handleBlur = () => {
    this.setState({
      focused: false,
    });
  };

  render() {
    const { intl: { formatMessage }, clientData: { phone } } = this.props;
    const {
      timer,
      value, focused,
    } = this.state;
    const values = value.split('');
    return (
      <div className="otp">
        <section className="otp__box">
          <img src={MarkazIcon} alt="markaz logo" width={250} style={{ height: 'auto', margin: '0 auto 40px auto' }} />
          <h5>
            {formatMessage({ id: 'otp.enterOTP' })}
            <br />
            {' '}
            <b>{phone}</b>
          </h5>
          <div className="otp__box__input" onClick={this.handleFocus}>
            {CODE_LENGTH.map((v, index) => {
              // current index
              const selected = values.length === index;
              const filled = values.length === CODE_LENGTH.length && index === CODE_LENGTH.length - 1;
              return (
                <div
                  key={index}
                  className={`otp__box__input__box ${((selected && focused) || filled) ? 'otp__box__input__box--active' : ''}`}
                >
                  {values[index]}
                </div>
              );
            })}
            <input
              value=""
              type="number"
              ref={this.input}
              onBlur={this.handleBlur}
              onChange={this.handleChange}
              onKeyUp={this.handleKeyUp}
            />
          </div>
          <article className={`otp__box__resend-code ${timer !== 0 ? 'otp__box__resend-code--active' : ''}`}>
            <p>{formatMessage({ id: 'otp.notReceivedOtp' })}</p>
            {timer === 0 ? (
              <b onClick={this.handleResendCode}>{formatMessage({ id: 'otp.resendCode' })}</b>
            ) : (
              <b>{formatMessage({ id: 'otp.requestNewCodeIn' }, { time: moment(timer).zone(-120).format('mm:ss') })}</b>
            )}
          </article>
        </section>
      </div>
    );
  }
}

const mapStateToProps = ({ rootState }) => ({
  clientData: rootState.clientData,
});

const mapDispatchToProps = ({
  onHandleOTP: handleOTP,
  onHandleResendOTP: handleResendOTP,
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(OTP));
